var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import styled from "styled-components";
export var SpanUnderlineOnHover = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"], ["\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"])));
var EnvironmentsView = /** @class */ (function (_super) {
    __extends(EnvironmentsView, _super);
    function EnvironmentsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EnvironmentsView.prototype.render = function () {
        var _this = this;
        if (this.props.environments.length === 0) {
            return [];
        }
        var envs = this.props.environments
            .map(function (element, index) { return (element === _this.props.selectedEnv) ? React.createElement("b", null, element) :
            React.createElement(SpanUnderlineOnHover, { key: index, onClick: function () { return _this.props.setSelectedEnv(index); } }, element); })
            .reduce(function (prev, curr) { return React.createElement(React.Fragment, null,
            prev,
            " | ",
            curr); });
        return (React.createElement("div", { style: this.props.style == null ? {} : this.props.style }, envs));
    };
    return EnvironmentsView;
}(React.Component));
export { EnvironmentsView };
var templateObject_1;
